import { LOTOFACIL_STRATEGIC_COVERINGS } from "./lotofacil-strategic-data";

const cache: Record<string, number[][]> = {};

function decode(encoded: string): number[][] {
  return encoded
    .trim()
    .split(/\s+/)
    .map((token) =>
      Array.from(token, (char) => char.charCodeAt(0) - 65).sort((a, b) => a - b),
    );
}

/**
 * Sistemas publicados para Lotofácil na semântica (v,15,t,15): se as 15 dezenas
 * sorteadas estiverem dentro do universo escolhido, algum jogo atinge t acertos.
 */
export function lookupLotofacilStrategicCovering(v: number, t: number): number[][] | null {
  const key = `${v}_${t}`;
  const encoded = LOTOFACIL_STRATEGIC_COVERINGS[key];
  if (!encoded) return null;
  cache[key] ??= decode(encoded);
  return cache[key];
}